import React from "react";
import { withTranslation } from "react-i18next";
import ModuleList from "./ModuleList";
import { Accordion, AccordionSummary, AccordionDetails, Stack, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const DeviceItem = React.memo(({ device, t }) => (
  <React.Fragment>
    <Accordion
      defaultExpanded={device.hwId !== "EdgeDevice"}
      disableGutters
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "common.white" }} />}
        sx={{ borderBottom: "0px solid", borderColor: "primary.main", bgcolor: "background.light" }}
      >
        <Typography sx={{ flex: 1, fontWeight: "bold" }}>
          {device &&
            <Stack direction="column">
              <Typography variant="h6" >{device.name}</Typography>
              {device.tag && <Typography sx={{ fontSize: "10px" }} >{device.tag}</Typography>}
            </Stack>
          }
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0, m: 0 }}>
        <ModuleList
          hwId={device.hwId}
          list={device.measurements}
          title={t("Measurements")}
        />
        {device.hwId !== "EdgeDevice" && <ModuleList
          hwId={device.hwId}
          list={device.diagnostics}
          title={t("Diagnostics")}
        />}
      </AccordionDetails>
    </Accordion>
  </React.Fragment >
));

export default withTranslation("common")(DeviceItem);
